import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import { useQuery } from '../utils/tools'
import useTickers from '../hooks/useTickers'
import useDatasets from '../pages/visualization/hooks/useDatasets'
import { useGeneral } from './general'
import axios from 'axios'

const ProjectContext = createContext()

export const ProjectProvider = ({ children }) => {
    const query = useQuery()
    const { checkPrivateCompany, tickers } = useTickers()
    const projectId = query.get('projectId')
    const [ tickerInfo, setTickerInfo ] = useState({})
    const [ isEmpty, setIsEmpty ] = useState(null)
    const [ticker, setTicker] = useState('')
    const [colapseAllSections, setColapseAllSections] =useState(false)
    const [sections,setSections] = useState([])
    const [projectName, setProjectName] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [dataset,  setDataset] = useState('')
    const [earningsData, setEarningsData] = useState({})
    const [doesProjectExist, setDoesProjectExist] = useState(true)
    const [ topRated, setTopRated ] = useState()
    const { datasets, getColumns } = useDatasets(ticker)
    const {userAlerts, setprojectTickerData, projectTickerData} = useGeneral()
    const [ColumnGranularityOptions, setColumnGranularityOptions] = useState([])

    const privateCompany = useMemo(()=> tickers.length ? checkPrivateCompany(ticker) : null, [ticker, tickers]) // eslint-disable-line
    const projectAlerts = useMemo(()=> userAlerts?.filter(alert => alert.ticker === ticker ), [userAlerts, ticker])

    useEffect(() => {
        if(ticker && tickers.length){
            const companyName = tickers?.find(data => data.value === ticker)?.name 
            setTickerInfo({...tickerInfo, companyName})
        }
        return () => {}
    },[tickers, ticker]) // eslint-disable-line

    useEffect(() => {
        ticker && (async () => {
            const resJson = await axios.get(`/api/getInfo?ticker=${ticker}`)
            const res = await resJson.data
            setTickerInfo(res)
        })()
        return () => setTickerInfo({})
    },[ticker]) 

    useEffect(() => {
        ticker && (async () => {
            const tickerInfo = await axios.get(`/api/getTickerInfo?ticker=${ticker}`)
            const Info = await tickerInfo.data
            setprojectTickerData(Info)
        })()
        return () => {}
    },[ticker]) 

    useEffect(() => {
        ticker && (async () => {
            const resJson = await axios.get(`/api/getTopRatedPerTicker?ticker=${ticker}`)
            const res = await resJson.data
            setTopRated(res)
        })()
        return () => setTopRated()
    },[ticker]) 

    useEffect(() =>{

        ticker && (async () => {
            const resJson = await axios.get(`/api/getColumnGranularityOptions`)
            const res = await resJson.data
            setColumnGranularityOptions(res)
        })()
        return () => setColumnGranularityOptions()
        
    },[ticker])

    useEffect(() => {
        
        projectId && projectId != "null"&& axios.get(`/api/getProject?projectId=${projectId}`)
        .then(res => res.data)
        .then(res => {
            if (res.status === 404) return setDoesProjectExist(false)
            const feed = query.get('feed') === 'true'
            setTicker(res.ticker)
            setSections(res.sections)
            setProjectName(res.name)
            setIsEmpty(feed || res.isEmpty)
            getProjectEarningsData(res.ticker)
        })
        return () => {
            setTicker('')
            setSections([])
            setProjectName(null)
            setIsEmpty(null)
        }
    }, [projectId]) // eslint-disable-line

    const clearProject = () => {
        // fetch('/api/clearProject', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({projectId})
        // })
        axios({
            method: 'POST',
            url:'/api/clearProject',
            data:{projectId}
        })
        .then(res => res.data)
        .then(res => {
            setIsEmpty(true)
            setSections([res.uuid])
        })  
    }

    const getProjectEarningsData = (ticker) => {
        // fetch('/api/getCompanyEarnings', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ticker})
        // })
        axios({
            method: 'POST',
            url:'/api/getCompanyEarnings',
            data:{ticker}
        })
        .then(res => res.data)
        .then(res => {
            setEarningsData(res.data)
        })  
    }

    // sections
    const handleReorderSections = (newSectionsOrder) => {
        setSections(newSectionsOrder)
        updateSectionsOrder(newSectionsOrder)
    }

    const updateSectionsOrder = (newOrderedSections) => {
        // fetch('/api/updateProjectSections', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({projectId, newSections:newOrderedSections})
        // })
        axios({
            method: 'POST',
            url:'/api/updateProjectSections',
            data:{projectId, newSections:newOrderedSections}
        })
    }

    const addPanel = () => {
        // fetch('/api/newSection', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({project_uuid: projectId})
        // })
        axios({
            method: 'POST',
            url:'/api/newSection',
            data:{project_uuid: projectId}
        })
        .then(res => res.data)
        .then(res => setSections([...sections, res['uuid']]))
        window.scrollTo({ top: document.body.scrollHeight, left: 0, behavior: 'smooth' })
    }

    useEffect(()=>{
        colapseAllSections && setColapseAllSections(false)
        return () => {}
    },[colapseAllSections])

    const colapseAll = () => {
        // fetch('/api/sectionsExpand', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         sections,
        //     })
        // })
        axios({
            method: 'POST',
            url:'/api/sectionsExpand',
            data:{sections}
        })
        setColapseAllSections(true)
    }

    const deleteSection = (sectionId) => {
        // fetch('/api/removeSections', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         sectionId,
        //     })
        // })
        axios({
            method: 'POST',
            url:'/api/removeSections',
            data:{sectionId}
        })
        setSections(sections.filter(section => section !== sectionId))
    }

    const duplicateSection = (sectionId ) => {
        setIsLoading(true)
        // fetch('/api/duplicateSection', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({sectionId})
        // })
        axios({
            method: 'POST',
            url:'/api/duplicateSection',
            data:{sectionId}
        })
        .then(res => res.data)
        .then(res => {
            const newSectionsOrder = [...sections]
            newSectionsOrder.splice(newSectionsOrder.indexOf(sectionId) + 1, 0, res['uuid'])

            setSections(newSectionsOrder)
            setIsLoading(false)
            updateSectionsOrder(newSectionsOrder)
            window.scroll({top: 400, behavior: 'smooth'})
        })
    }

    const updateAllSectionsDataset = (data) => {
        const newData = data?.filter(d => !dataset.includes(d))
        data && setDataset([...dataset, ...newData])
    }

    return (
        <ProjectContext.Provider value={{
            projectId,
            ticker,
            privateCompany,
            sections,
            projectName,
            colapseAll,
            deleteSection,
            duplicateSection,
            addPanel,
            colapseAllSections,
            setColapseAllSections,
            tickerInfo,
            datasets,
            clearProject,
            isEmpty,
            isLoading,
            dataset,
            updateAllSectionsDataset,
            earningsData,
            handleReorderSections,
            getColumns,
            alertsData: projectAlerts,
            doesProjectExist,
            topRated,
            ColumnGranularityOptions
        }}>
            { children}
        </ProjectContext.Provider>
    )

}

export function useProject() {
    return useContext(ProjectContext)
}